/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import dayjs from "dayjs";
import { useQuery } from "react-query";
import { fetchAttendances } from "../../../../services";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const TimeLineItem = React.memo(({ time, employeeName }) => {
  const formattedTime = time ? dayjs.utc(time).format("hh:mm a") : "-";
  return (
    <div className="timeline-item align-items-start">
      <div
        className="timeline-label font-weight-bolder text-dark-75 font-size-lg"
        title={formattedTime}
      >
        {formattedTime}
      </div>

      <div className="timeline-badge">
        <i className="fa fa-genderless text-success icon-xl"></i>
      </div>

      <div className="timeline-content d-flex">
        <span className="font-weight-bolder text-dark-75 pl-3 font-size-lg">
          {employeeName || "-"}
        </span>
      </div>
    </div>
  )
});


export function ListsWidget9({ className }) {
  const today = dayjs().format("YYYY-MM-DDT00:00:00");
  const [page, setPage] = useState(1);
  const perPage = 5;

  const { data, isLoading } = useQuery(
    ["attendances", "tody", today, "latest", page],
    () => {
      const from = dayjs().subtract(1, "day").format("YYYY-MM-DDT00:00:00");
      const to = dayjs().subtract(1, "day").format("YYYY-MM-DDT23:59:59");

      const action = "in";
      return fetchAttendances(from, to, perPage, page, action)
    },
    { cacheTime: 60 * 1000, staleTime: 30 * 1000 }
  );

  let attendances = isLoading ? [] : data?.data?.data;
  const total = isLoading ? 0 : data?.data?.meta?.total;
  const totalPages = Math.ceil(total / perPage);


  return (
    <>
      <div className={`card card-custom  ${className}`}>
        {/* Header */}
        <div className="card-header align-items-center border-0 mt-4">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bolder text-dark">Today Check-Ins</span>
          </h3>
        </div>

        {/* Body */}
        <div className="card-body pt-4"
          style={{ height: "250px", overflowY: "auto" }}
        >
          <div className="attendances timeline timeline-6 mt-3">
            {attendances &&
              attendances.map((item) =>
                <TimeLineItem
                  key={item?.id}
                  time={item?.created_at}
                  employeeName={item?.employee?.name}
                />
              )}
            {/* {
              (!attendances || attendances.length === 0) && <div className="text-center text-muted">No data available yet</div>
            } */}
          </div>
        </div>

        {/* Pagination */}
        <div className="card-footer d-flex justify-content-between">
          <button
            className="btn btn-sm btn-light"
            disabled={page === 1}
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          >
            Previous
          </button>
          <span className="align-self-center">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-sm btn-light"
            disabled={page === totalPages}
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}
